import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export const PublicFooter: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="landing-footer">
      <div className="landing-container">
        <div className="landing-footer-top">
          <div className="landing-footer-brand">
            <img src="/assets/ventilio.png" alt="Ventilio" className="landing-footer-logo" />
            <p>La solution de gestion de projet visuelle et collaborative.</p>
          </div>
          <div className="landing-footer-column">
            <h4>Produit</h4>
            <a href="/#features">Fonctionnalités</a>
            <Link to="/tarifs">Tarifs</Link>
          </div>
          <div className="landing-footer-column">
            <h4>Entreprise</h4>
            <a href="https://id-ingenierie.com/" target='_blank' rel='noopener noreferrer'>
              À propos
              <svg className="landing-footer-ext-icon" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round"><path d="M7 17L17 7"/><path d="M8 7h9v9"/></svg>
            </a>
            <Link to="/contact">Contact</Link>
          </div>
          <div className="landing-footer-column">
            <h4>Support</h4>
            <Link to="/help">Aide</Link>
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/documentation'); }} style={{ cursor: 'pointer' }}>Documentation</a>
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/api-documentation'); }} style={{ cursor: 'pointer' }}>API</a>
          </div>
        </div>
        <div className="landing-footer-bottom">
          <p>&copy; 2026 Ventilio. Tous droits réservés.</p>

          <div className="landing-footer-legal">
            <Link to="/cgu">CGU</Link>
            <Link to="/cgv">CGV</Link>
            <Link to="/privacy">Confidentialité</Link>
            <Link to="/cookies-policy">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
